var map = {
	"./arrow-down.svg": 731,
	"./arrow-left.svg": 833,
	"./barcode.svg": 820,
	"./battery.svg": 573,
	"./cash.svg": 468,
	"./close.svg": 420,
	"./credit-card.svg": 721,
	"./minus.svg": 475,
	"./plus.svg": 189,
	"./ruler.svg": 251,
	"./wifi.svg": 617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 254;